export const QUOTE_FEATURE = 'quote';
export const QUOTE_CORE_FEATURE = 'quoteCore';
